import React from 'react';
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";


const SocialMedia = () => {
  return (
    <div className='app__social'>
        <a href='https://twitter.com/jamerZdev'>
           <BsTwitter />
        </a>
        <a href='#'>
           < FaFacebook />
        </a>
        <a href='https://www.instagram.com/jac_miles_/'>
           <BsInstagram />
        </a>
    </div>
  )
}

export default SocialMedia